import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { ReceivableCurrency } from "../../../utils/types";

export const formatTaxValue = (currency: ReceivableCurrency, value: number) => {
  const prefix =
    currency === ReceivableCurrency.BRL
      ? "R$"
      : currency === ReceivableCurrency.USD
        ? "US$"
        : "€";
  return `${prefix} ${value.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const formatTaxDate = (value?: string) => {
  if (!value) return "—";
  try {
    return format(new Date(value), "dd/MM/yyyy HH:mm", { locale: ptBR });
  } catch {
    return value;
  }
};

